"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getLink = getLink;

var _urlParse = _interopRequireDefault(require("url-parse"));

var _productsStatus = require("./productsStatus");

function getLink(currentProduct, environment, products, productId, productsStatus, swicusOrgId) {
  var product = products.find(function (p) {
    return p.id === productId;
  });

  if (!swicusOrgId) {
    return createSignUpLink(currentProduct, environment, product);
  } else if (shouldProductRedirectToLogin(productsStatus, productId)) {
    return transformUrl(currentProduct, product.url.login[environment], swicusOrgId);
  }
}

function transformUrl(currentProduct, url, swicusOrgId) {
  if (currentProduct) {
    var parsedUrl = (0, _urlParse["default"])(url, true);
    parsedUrl.query.utm_source = currentProduct;
    parsedUrl.query.utm_medium = 'app_switcher';

    if (swicusOrgId) {
      parsedUrl.query.swicus_org_id = swicusOrgId;
    }

    return parsedUrl.toString();
  }

  return url;
}

function shouldProductRedirectToLogin(productsStatus, productId) {
  var status = productsStatus[productId];
  return status === _productsStatus.PRODUCT_STATUS.CAN_SWITCH || status === _productsStatus.PRODUCT_STATUS.NO_STATUS || !status;
}

function createSignUpLink(currentProduct, environment, product) {
  return transformUrl(currentProduct, product.url.signup[environment]);
}